export default {
  PENDING: 10, // 保留中
  FINISHED: 20, // 終了
  CANCELLED: 30 // 中止
};
